import { z } from 'zod';
import { COORDINATOR_ROLES } from '../constants';

/** Grant an address access on Nastavitve → Uporabniki (SPEC §1.1L). */
export const coordinatorGrantSchema = z.object({
  email: z.string().trim().toLowerCase().pipe(z.email()),
  name: z.string().trim().max(200).default(''),
  role: z.enum(COORDINATOR_ROLES),
});
export type CoordinatorGrant = z.infer<typeof coordinatorGrantSchema>;

export const coordinatorRoleSchema = z.object({ role: z.enum(COORDINATOR_ROLES) });

/** A coordinator's full name, set by themselves or on Uporabniki. */
export const coordinatorNameSchema = z.object({ name: z.string().trim().min(1).max(200) });
